var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PanelRow", { staticClass: "oneline" }, [
    _c(
      "ul",
      { staticClass: "apps" },
      _vm._l(_vm.apps, function(app, appname) {
        return _c(
          "Panel",
          {
            key: appname,
            tag: "li",
            staticClass: "panel",
            class: {
              open: _vm.open === appname,
              beforeopen: _vm.beforeopen === appname
            },
            attrs: { tag: "li" }
          },
          [
            _vm.open === appname
              ? _c("article", [
                  _c("h3", [
                    _vm._v(_vm._s(_vm._f("trans")("apps.description")))
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm._f("trans")(app.description)))])
                ])
              : _c("router-link", { attrs: { to: app.url } }, [
                  _c("figure", [
                    _c("img", { attrs: { src: app.logo, alt: "" } })
                  ])
                ]),
            _vm._v(" "),
            _c(
              "nav",
              [
                _c(
                  "router-link",
                  { staticClass: "link", attrs: { to: app.url } },
                  [_c("h2", [_vm._v(_vm._s(_vm._f("trans")(app.name)))])]
                ),
                _vm._v(" "),
                app.description
                  ? _c(
                      "button",
                      {
                        staticClass: "btn inverse info",
                        on: {
                          click: function($event) {
                            _vm.open = _vm.open !== appname && appname
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("trans")(
                                _vm.open === appname
                                  ? "buttons.back"
                                  : "buttons.info"
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-725be691", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-725be691","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/general/Apps.vue
// module id = null
// module chunks = 